import * as React from "react";
import { type ReactNode } from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import LocalPopup from "./LocalPopup";
import PopupManager, { type PopupType } from "./PopupManager";

type Props = {};

type State = {
    popups: Array<PopupType>;
};

export default class LocalPopupContainer extends React.Component<Props, State> {
    public state: State = {
        popups: [],
    };

    public componentDidMount(): void {
        PopupManager.addListener(this.handlePopupsChange);
    }

    public componentWillUnmount(): void {
        PopupManager.removeListener(this.handlePopupsChange);
    }

    public handlePopupsChange = (popups: Array<PopupType>): void => {
        const selected = [];

        for(let i = 0, l = popups.length; i < l; i++) {
            if(!popups[i].local) {
                continue;
            }

            selected.push(popups[i]);
        }

        this.setState({
            popups: selected,
        });
    };

    public render(): ReactNode {
        return (
            <div id="local-popups">
                {this.state.popups.map((popup) => {
                    let icon: ReactNode;

                    if(popup.icon) {
                        if(typeof popup.icon === "string") {
                            icon = <FontAwesomeLight icon={popup.icon as IconProp} />;
                        } else {
                            icon = popup.icon as ReactNode;
                        }
                    }

                    let message;

                    if(typeof popup.message === "string") {
                        message = <p>{popup.message}</p>;
                    } else {
                        message = popup.message;
                    }

                    return (
                        <LocalPopup
                            classes={popup.classes}
                            key={popup.id}
                            icon={icon}
                            id={popup.id}
                            wobble={popup.wobble}
                        >
                            {message}
                        </LocalPopup>
                    );
                })}
            </div>
        );
    }
}
